<template>
  <div class="layout-onboarding">
    <div class="onboarding-wrapper">
      <div class="content-wrapper">
        <div class="logo-wrapper">
          <img
            class="simpan-for-biz-logo"
            :src="`${images}/simpan_logo.png`"
            alt="simpan_logo"
          >
        </div>
        <h1>Dashboard</h1>
        <div class="uk-card uk-card-body onboarding-card">
          <h3>Masuk</h3>
          <Form
            :validation-schema="schema" 
            @submit="onSubmit"
          >
            <div class="uk-margin uk-text-left">
              <h4>Email</h4>
              <div class="uk-inline uk-width-1-1">
                <Field
                  name="email"
                  class="uk-input"
                  type="text"
                  autocomplete="on"
                  placeholder="Masukkan Email"
                />
                <ErrorMessage
                  name="email"
                  as="p"
                  class="error"
                />
              </div>
            </div>
            <div class="uk-margin-small uk-text-left">
              <h4>Password</h4>
              <div class="uk-inline uk-width-1-1 password-field">
                <img
                  v-if="isVisible"
                  class="uk-form-icon-custom uk-form-icon-flip"
                  :src="`${images}/icon/ic_eye_off.svg`"
                  alt="eye-on-icon"
                  @click="isVisible = !isVisible"
                >
                <img
                  v-else
                  class="uk-form-icon-custom uk-form-icon-flip"
                  :src="`${images}/icon/ic_eye_on.svg`"
                  alt="eye-off-icon"
                  @click="isVisible = !isVisible"
                >
                <Field
                  name="password"
                  class="uk-input"
                  :type="isVisible ? 'password' : 'text'"
                  placeholder="Masukkan Password"
                  autocomplete="on"
                />
              </div>
              <ErrorMessage
                name="password"
                as="p"
                class="error"
              />
            </div>
            <div class="uk-margin uk-flex uk-flex-right">
              <router-link
                to="/forgot-password"
                class="uk-text-bold"
              >
                <h4 style="color: #004FA4;">
                  Lupa Password
                </h4>
              </router-link>
            </div>

            <button
              v-if="is_loading"
              class="uk-button blue disabled uk-width-expand"
              disabled
            >
              <div uk-spinner />
            </button>
            <button
              v-else
              class="uk-button blue uk-width-expand"
            >
              Masuk
            </button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Yup from 'yup'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { PREFIX_IMAGE } from '@/utils/constant'
import { Form, Field, ErrorMessage } from 'vee-validate'

export default {
  components: {
    Form,
    Field,
    ErrorMessage
  },
  data() {
    const schema = Yup.object({
      email: Yup.string().trim().required('Email wajib diisi').email('Mohon memasukan alamat email yang benar'),
      password: Yup.string().trim().required('Password wajib diisi').min(8, 'Minimal password 8 karakter')
    })
    return {
      is_loading: false,
      images: PREFIX_IMAGE,
      isVisible: true,
      schema
    }
  },
  computed: {
    ...mapGetters({
      getToggleModalAddEditDiscard: 'auth/get_toggle_modal_add_edit_discard'
    })
  },
  methods: {
    ...mapActions({
      loginUser: 'auth/login'
    }),
    ...mapMutations({
      setToggleModalAddEditDiscard: 'auth/SET_TOGGLE_MODAL_ADD_EDIT_DISCARD'
    }),
    onSubmit(values) {
      this.login({
        ...values,
        email: values.email.trim(),
        password: values.password.trim()
      })
    },
    async login(values) {
      this.is_loading = true
      await this.loginUser({ ...values, redirect: this.$route.query.redirect })
      this.is_loading = false
    }
  }
}
</script>

<style scoped>
 .uk-margin-large-top {
    width: 100%;
    max-width: 100%;
    display: flex;
    margin-top: 0 !important;
  }
  .uk-input {
    height: 50px;
  }
  h1 {
    font-family: 'PoppinsBold';
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 150%;
    text-align: center;
    color: #004FA4;
    margin: 0px 0px 26px 0px;
  }
  h3 {
    font-family: 'PoppinsBold';
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 150%;
    text-align: left;
    color: #1B4DB3;
    margin-bottom: 12px;
  }
  h4 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    color: #1F242E;
    margin-bottom: 8px;
  }
  .uk-form-icon-custom {
    position: absolute;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    top: 14px;
    right: 15px;
    cursor: pointer;
  }
</style>
